module.exports = __webpack_public_path__ + "static/img/icon h wordys.dfc1306d.svg";